<template>
    <q-modal v-model="show_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" @hide="hideCertificate()">
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="hideCertificate()" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('certificate') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="flex justify-around q-mb-sm">
                    <div v-if="show_modal && site_url && certificate" :class="$q.platform.is.mobile ? 'q-mb-sm' : ''">
                        <social-sharing :url="site_url"
                            :title="`${full_name} ${$t('got_a_certificate_on_the_training')} ${certificate.webcast_title}`"
                            :description="`${full_name} ${$t('got_a_certificate_on_the_training')} ${certificate.webcast_title}`"
                            :quote="`${full_name} ${$t('got_a_certificate_on_the_training')} ${certificate.webcast_title}`"
                            :networks="overriddenNetworks"
                            inline-template
                        >
                            <div class="flex">
                                <network class="q-mr-xs" network="facebook" id="facebook" >
                                    <q-btn  color="secondary" icon="fab fa-facebook-f" />
                                </network>

                                <network class="q-mr-xs" network="linkedin" id="linkedin">
                                    <q-btn color="secondary" icon="fab fa-linkedin-in" />
                                </network>

                                <network class="q-mr-xs" network="twitter" id="twitter">
                                    <q-btn color="secondary" icon="fab fa-twitter" />
                                </network>

                                <network class="q-mr-xs" network="whatsapp" id="whatsapp">
                                    <q-btn color="secondary" icon="fab fa-whatsapp" />
                                </network>
                            </div>
                        </social-sharing>
                    </div>
                    <div v-if="!$q.platform.is.mobile">
                        <q-btn color="secondary" :label="$t('print_certificate')" icon="fas fa-print" @click="print()" />
                    </div>
                </div>

                <div class="print-certificate certificate text-center desktop-only">
                    <img :src="data.image" />
                </div>

                <div class="print-certificate certificate-mobile text-center mobile-only">
                    <img :src="data.image" />
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['data', 'show', 'certificate'],

    data() {
        return {
            overriddenNetworks: {
                'custom': {
                    'sharer': process.env.SITE_URL,
                    'type': 'popup'
                },
            }
        }
    },

    computed: {
        ...mapGetters({
            full_name: 'common/full_name',
        }),

        show_modal: {
            get() {
                return this.show
            },
            set(val) {
                this.$emit('hideCertificate')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        site_url() {
            return process.env.SITE_URL
        }
    },

    methods: {
        hideCertificate() {
            this.$emit('hideCertificate')
        },

        print() {
            let certificate = document.querySelector(".print-certificate").innerHTML
            let html =
            `
            <html>
                <head></head>
                    <style type="text/css" media="print">
                        @page {
                            size: landscape;
                        }
                        .printable.box {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            height: 90vh;
                        }
                    </style>
                    <body>
                        <div class="printable">
                            <div class="printable box">
                                ${certificate}
                            </div>
                        </div>
                    </body>
            </html>
            `

            let myWindow = window.open('','','')
            if (myWindow.document) {
                myWindow.document.write(html)

                myWindow.document.close()
                myWindow.focus()
                setTimeout(() => {
                    myWindow.print()
                }, 200)
            } else return

        }
    }
}
</script>

<style lang="stylus" scoped>
.certificate
    & img
        width auto
        height 100%

.certificate-mobile
    & img
        width 100%
        height auto
</style>
